@if (newsItem) {
  @if (general){
    <card-block
    onScrollView (viewStateChange)="trackViewListItem($event.isVisible)" [once]="true"
    [state]="{ itemListId: itemListId, itemListName: itemListName}"
    class="h-full w-full mb-5 bg-white shadow-card"
    [id]="newsItem._id"
    [title]="newsItem.title"
    [text]="newsItem.summary"
    [image]="newsItem.image"
    [fallbackImage]="newsFallbackImage"
    [imageSizes]="imageSizes"
    [views]="newsItem.views"
    [url]="absoluteUrl ? (newsItem | getNewsUrl:newsItem.company) : '../' + newsItem.slug"
    [itemIndex]="itemIndex"
    [footerTpl]="footerTpl"
    (onItemSelected)="trackItemSelected()">
    <ng-content></ng-content>
  </card-block>
  }
  @else if(newsItem.summary == 'Click here to see all the news available') {
    <card-block
    onScrollView (viewStateChange)="trackViewListItem($event.isVisible)" [once]="true"
    [state]="{ itemListId: itemListId, itemListName: itemListName}"
    class="h-full w-full mb-5 bg-gray-400"
    [id]="newsItem._id"
    [title]="newsItem.title"
    [text]="newsItem.summary"
    [imageSizes]="imageSizes"
    [views]="newsItem.views"
    [url]="absoluteUrl ? (newsItem | getNewsUrl:newsItem.company) : urlPrefix + newsItem.slug"
    [itemIndex]="itemIndex"
    [footerTpl]="footerTpl"
    (onItemSelected)="trackItemSelected()"
    [seeAll]="true">
    <ng-content></ng-content>
  </card-block>
  }
  @else {
    <card-block
    onScrollView (viewStateChange)="trackViewListItem($event.isVisible)" [once]="true"
    [state]="{ itemListId: itemListId, itemListName: itemListName}"
    class="h-full w-full mb-5 bg-white shadow-card"
    [id]="newsItem._id"
    [type]="type"
    [title]="newsItem.title"
    [text]="newsItem.summary"
    [image]="newsItem.image"
    [fallbackImage]="newsFallbackImage"
    [imageSizes]="imageSizes"
    [views]="newsItem.views"
    [url]="absoluteUrl ? (newsItem | getNewsUrl:newsItem.company) : urlPrefix + newsItem.slug"
    [itemIndex]="itemIndex"
    [footerTpl]="footerTpl"
    (onItemSelected)="trackItemSelected()"
    [isAccessibleForFree]="newsItem.isAccessibleForFree">
    <ng-content></ng-content>
  </card-block>
  }
  
} @else {
  <loading-card-block class="h-full w-full"></loading-card-block>
}
@if (newsItem?.newsStatus.includes(newsStatusEnum.companyDraft)) {
  <div class="status-label draft" i18n>draft</div>
}
@if (newsItem?.newsStatus.includes(newsStatusEnum.suspended)) {
  <div class="status-label suspended" i18n>suspended</div>
}
@if (newsItem?.timeToPublish) {
  <div class="status-label waiting"><span i18n>published</span> {{ newsItem.timeToPublish }}</div>
}
<ng-template #footerTpl>
  <div class="absolute right-2 bottom-1 text-lg italic">{{newsItem.publishDate | date:'fullDate'}} </div>
</ng-template>

